/*
 *   File : view-banner.js
 *   Author : https://evoqins.com
 *   Description : view banner of service and promotion banner component
 *   Integrations : NA
 *   Version : 1.0.0
*/

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const ViewBannerModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("view-banner-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade"
            id="view-banner-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="manageModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='view-banner-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                {props.type === 1 ?
                    <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">
                        {/* modal header */}
                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                {props.title}
                            </h6>
                            <Icon icon='close'
                                size="1.125rem"
                                className="d-flex cursor-pointer"
                                onClick={_handleCloseModal} />
                        </div>

                        <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                            <div className='e-bg-cultured-light border-radius-16 p-3'>
                                <p className='mb-1 e-text-smoky-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                    {props.data.title ?? "-"}
                                </p>
                                <p className='mb-2 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-24px'>
                                    {props.data.description ?? "-"}
                                </p>

                                {props.data.image_url !== null &&
                                    <img src={props.data.image_url}
                                        draggable={false}
                                        className='w-100 h-auto object-fit-contain'
                                        height={400}
                                        alt='banner' />
                                }
                            </div>
                        </div>

                        {/* Modal footer */}
                        <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-3'>
                            <SecondaryButton name="Cancel"
                                paddingBlock="padding-14px-tb padding-54px-lr"
                                onClick={_handleCloseModal} />

                            <PrimaryButton name={"Done"}
                                paddingBlock="padding-14px-tb px-3"
                                className='w-186px'
                                onClick={_handleCloseModal} />
                        </div>
                    </div>
                    :
                    <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">
                        {/* modal header */}
                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                {props.title}
                            </h6>
                            <Icon icon='close'
                                size="1.125rem"
                                className="d-flex cursor-pointer"
                                onClick={_handleCloseModal} />
                        </div>

                        <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                            <div className='e-bg-cultured-light border-radius-16 p-3'>

                                <p className='mb-1 e-text-smoky-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                    {props.data.title ?? "-"}
                                </p>
                                <p className='mb-2 e-text-smoky-black e-primary-font e-font-14 e-font-weight-400 line-height-24px'>
                                    {props.data.description ?? "-"}
                                </p>

                                {props.data.image_url !== null &&
                                    <img src={props.data.image_url}
                                        draggable={false}
                                        className='w-100 h-auto object-fit-contain'
                                        height={400}
                                        alt='banner' />
                                }
                            </div>
                        </div>

                    </div>
                }
            </div>
        </div>
    )
}

export default ViewBannerModal;